var map = {
	"./1.png": 234,
	"./2.png": 235,
	"./download.png": 236,
	"./friend.png": 155,
	"./friend2.png": 156,
	"./home-header-bg.png": 237,
	"./inventory-header.png": 238,
	"./inventory-title.png": 239,
	"./phone.png": 157,
	"./phone2.png": 240,
	"./pic.png": 241,
	"./shadow.png": 242,
	"./stall-address.png": 158,
	"./statistics1.png": 159,
	"./statistics2.png": 160,
	"./store.png": 161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;